import Button, { BUTTON_VARIANTS } from "@shared/ui/Button";
import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import Headline, { HEADLINE_SIZES } from "@shared/ui/Headline";
import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

/**
 * Shared presentational component for all error states.
 *
 * variant="crash"    → JS / render error  (Oops! + reload link)
 * variant="notFound" → 404                (status code + home link)
 * variant="forbidden" → 403               (status code + home link)
 * variant="server"   → 5xx               (status code + home link)
 */
export default function ErrorScreen({
  variant = "crash",
  statusCode,
  message,
}) {
  const { messages } = useIntl();

  const navigate = useNavigate();

  if (variant === "crash") {
    const msgs = messages["common"]["crash"];
    return (
      <div className="w-screen h-screen flex flex-col justify-center items-center space-y-lg">
        <Headline size={HEADLINE_SIZES.X_LARGE}>{msgs["title"]}</Headline>
        <BodyText
          size={BODY_TEXT_SIZES.MEDIUM}
          style={{ maxWidth: "382px" }}
          className="text-center !mt-3xl"
          color="text-secondary"
        >
          {msgs["desc1"]}
          <a
            href="mailto:support@makula.io"
            className="underline underline-offset-2 hover:cursor-pointer"
          >
            {msgs["desc2"]}
          </a>
          {msgs["desc3"]}
        </BodyText>
        <div className="flex space-x-lg">
          <Button
            text={msgs["reload"]}
            className="!mt-xl"
            onClick={() => window.location.reload()}
          />
          <Button
            text={msgs["goHome"]}
            variant={BUTTON_VARIANTS.OUTLINE}
            className="!mt-xl"
            onClick={() => navigate("/app/work")}
          />
        </div>
      </div>
    );
  }

  return (
    <section className="errorPage">
      <hgroup className="errorPage-hgroup">
        <h1>{statusCode}</h1>
        <h2>We got a problem</h2>
      </hgroup>
      <div className="errorPage-text">
        <p className="lead">{message}</p>
        <p>
          <a href="/">Click here</a> you will be redirected to the home page
        </p>
      </div>
    </section>
  );
}
